module.exports = __webpack_public_path__ + "static/media/JulianGarcia-resume.f76854ef.pdf";